// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {connect} from 'react-redux'

import Modal from '../Modal'
import {login, logout} from '../../actions/user'
import {showAreYouThere} from '../../actions/areYouThere'

import './index.css'

export class AreYouThere extends Component {

  renderAreYouThere = () => {
    return (
      <div className='are-you-there'>
        <div className='inner-div col-md-4 col-md-offset-4 col-6' onMouseDown={e => e.stopPropagation()}>
          <div className='row title'>
            <div className='col'>
              <span>Are you still there ?</span>
            </div>
          </div>
          <div className='row text'>
            <div className='col'>
              <span>Your session is about to expire due to inactivity.</span>
            </div>
          </div>
          <div className='row buttons'>
            <div className='col-md-6 col-6'>
              <button className='btn btn-cancel' onClick={() => this.props.showAreYouThere(false)}>Keep me signed in</button>
            </div>
            <div className='col-md-6 col-6'>
              <button className='btn btn-accept' onClick={this.props.logout}>Sign me out</button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderExipredSession = () => {
    return (
      <div className='are-you-there'>
        <div className='inner-div col-md-4 col-md-offset-4' onMouseDown={e => e.stopPropagation()}>
          <div className='row text'>
            <div className='col'>
              <span>
                You have been signed out of the
                Verimatrix portal due to inactivity.
                Sign in again to continue working.
              </span>
            </div>
          </div>
          <div className='row buttons centered-buttons'>
            <div className='col-md-6'>
              <button className='btn btn-cancel' onClick={this.props.logout}>OK</button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render () {
    return (
      this.props.areYouThere.show &&
          <Modal onHide={() => {}}>
            {this.props.areYouThere.expiredSession ?
              this.renderExipredSession() :
              this.renderAreYouThere()
            }
          </Modal>
    )
  }
}


function mapStateToProps ({areYouThere}) {
  return {areYouThere}
}

export default connect(mapStateToProps, {login, logout, showAreYouThere})(AreYouThere)
